$(function() {

	$('#filters').each(function() {

		var $filters = $(this),
			$form = $('#filters-form'),
			busy = false;
		if (!$filters.length) return false;

		function close(e) {
			if (busy) return false;
			busy = true;
			$('body').removeClass('filters-animated');
			setTimeout(function() {
				$('body').removeClass('filters-visible');
				busy = false;
			}, 300);
			return false;
		}

		function open(e) {
			if ($(this).parent().hasClass('disabled')) return false;
			if (busy) return false;
			busy = true;
			e.stopPropagation();
			$('body').addClass('filters-visible');
			setTimeout(function() {
				$('body').addClass('filters-animated');
				window.serendis.initSelect2();
				$('#filters .filter').first().filter(':text').focus().select();
				busy = false;
			}, 100);
			return false;
		}

		$('#show-filters').click(open);

		$('#filters-cancel').click(close);

		$(window).keyup(function(e) {
			if (e.which === 27) close();
		});

		$(window).click(function(e) {
			if ($(e.target).attr('id') != 'filters' && !$(e.target).parents('#filters').length && !$(e.target).hasClass('select2-selection__choice__remove')) {
				close();
			}
		});

		$('#filters-reset').click(function() {
			$('#filters-filters').find(':input').val('');
			$form.submit();
			return false;
		});

	});

});